var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 7.5C6.38403 7.5 3.25 10.603 3.25 14.4307V50.5693C3.25 54.397 6.38403 57.5 10.25 57.5H22.25V55.5198H10.25C7.48853 55.5198 5.25 53.3034 5.25 50.5693V30.9088L11.71 33.2924C12.019 33.4604 12.353 33.5853 12.7046 33.6594L12.9167 33.7376V33.6975C13.0935 33.724 13.2744 33.7376 13.4583 33.7376C15.5525 33.7376 17.25 31.9645 17.25 29.7772C17.25 27.5899 15.5525 25.8168 13.4583 25.8168L13.3931 25.8174C13.3645 25.8179 13.3359 25.8187 13.3076 25.8199C13.262 25.8217 13.2166 25.8244 13.1714 25.828C13.0857 25.8347 13.0007 25.8444 12.9167 25.857V25.8168L12.7046 25.8951C12.353 25.9692 12.019 26.094 11.71 26.2621L5.25 28.6457V14.4307C5.25 11.6966 7.48853 9.4802 10.25 9.4802H30.25V17.896C30.25 20.0833 32.0408 21.8564 34.25 21.8564H43.25V36.5198H45.25V21.7825C45.25 21.2443 45.0288 20.7294 44.6372 20.3561L31.7341 8.05385C31.3616 7.69852 30.8643 7.5 30.3469 7.5H10.25ZM15.0833 29.7772C15.0833 30.7146 14.3557 31.4745 13.4583 31.4745C12.5608 31.4745 11.8333 30.7146 11.8333 29.7772C11.8333 28.8398 12.5608 28.0799 13.4583 28.0799C14.3557 28.0799 15.0833 28.8398 15.0833 29.7772Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.095 45.999C51.095 46.9601 50.5457 47.4406 49.447 47.4406H48.0552V44.5257H49.447C50.5457 44.5257 51.095 45.0168 51.095 45.999Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.25 38.5C26.0408 38.5 24.25 40.2731 24.25 42.4604V53.5396C24.25 55.7269 26.0408 57.5 28.25 57.5H57.25C59.4592 57.5 61.25 55.7269 61.25 53.5396V42.4604C61.25 40.2731 59.4592 38.5 57.25 38.5H28.25ZM34.0261 51.3535H39.0181V53.5396H30.9861V51.4802L35.8982 44.5099H31.05V42.5H38.9861V44.399L34.0261 51.3535ZM43.4302 42.5V53.5396H40.6941V42.5H43.4302ZM48.0552 53.5396V49.5H49.751C50.6365 49.5 51.3884 49.4577 52.0071 49.1515C52.6257 48.8346 53.0898 48.4069 53.3992 47.8683C53.719 47.3192 53.8792 46.6961 53.8792 45.999C53.8792 44.8795 53.5271 43.9924 52.823 43.3376C52.1191 42.6723 51.095 42.5 49.751 42.5H45.3191V53.5396H48.0552Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 28.7871H23.25V30.7673H19.25V28.7871Z",
    fill: "#647B8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 28.7871H25.25V30.7673H29.25V28.7871Z",
    fill: "#647B8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 28.7871H35.25V30.7673H31.25V28.7871Z",
    fill: "#647B8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 28.7871H37.25V30.7673H41.25V28.7871Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileZip);
export default __webpack_public_path__ + "static/media/file-zip.84435c50.svg";
export { ForwardRef as ReactComponent };